import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import * as moment from 'moment';
import { AgentScheduleService } from 'src/app/services/agent-schedule.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';
import { ReservationsService } from 'src/app/services/reservations.service';

@Component({
  selector: 'app-assign-greet-dialog',
  templateUrl: './assign-greet-dialog.component.html',
  styleUrls: ['./assign-greet-dialog.component.scss']
})
export class AssignGreetDialogComponent implements OnInit {

  @Input() dialogData: any
  public event: EventEmitter<any> = new EventEmitter();

  schedules;
  employeeName;
  isUnAssigned;
  message;
  status;
  resData;
  isGreetAssignedFromWeb = false

  dailyCap;
  weeklyCap;

  constructor(public bsModalRef: BsModalRef,
    private reservationsService: ReservationsService,
    private spinner: NgxSpinnerService,
    private notifier: NotifierService,
    private agentSheduleService: AgentScheduleService) { }

  ngOnInit() {
    this.getWeeklyDaily();
   }

  close() {
    this.bsModalRef.hide()
  }

  assin(slot) {
    let postdata = {
      "resId": this.dialogData['resId'],
      "userId": this.dialogData['userId'],
      "startTime": this.dialogData['schedules']['resStartTime'],
      "endTime": this.dialogData['schedules']['resEndTime'],
      "slotId": 300
    }

    if (slot == null) {
      postdata['slotId'] = null
    } else {
      postdata['slotId'] = slot.scheduleId
    }
    this.spinner.show()
    this.agentSheduleService.assignReservation(postdata).subscribe(res => {
      this.isGreetAssignedFromWeb = res['status']
      this.spinner.hide()
      this.notifier.notify('success', res['message'])
      setTimeout(() => {
        if (res['status']) {
          this.triggerEvent(true)
          this.bsModalRef.hide();
        } else {
          this.triggerEvent(false)
          this.bsModalRef.hide();
        }
      }, 2000);
    })
  }

  getFormatedDate(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }

  triggerEvent(item) {
    this.event.emit({ data: item, res: 200 });
  }

  getWeeklyDaily(){
   let data = {
      userId : this.dialogData['userId'],
      date :this.dialogData['schedules']['resStartTime']
    }
     this.reservationsService.getAgentDailyCap(data).subscribe(result=>{
      //  console.log(result);
       this.dailyCap = result['result'][0];
     })
     this.reservationsService.getAgentWeeklyCap(data).subscribe(result=>{
      // console.log(result);
      this.weeklyCap = result['result'][0];
    })
  }
}
